import React from 'react';

import { flagStyles } from '../settings';

const SvgDJ = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-1344px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgDJ;
